/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import moment from 'moment';
import { Button } from 'react-toolbox/lib/button';
import Card from 'components/Card';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import S from '../styles.scss';
import { sortApptsByDate, filterApptsByTodayOrLater } from '../../../../../../../../utils/dateUtils';
import { RAILS_DATE, MOMENT_TIME, DISPLAY_DATE } from '../../../../../../../../shared/config/constants';

const FollowUpDeliveryCallScript = (props) => {
  const { title, phase: { appointments }, customerAnswered, deliveryOkay, handleBasicQuestion } = props;
  const appt = sortApptsByDate(filterApptsByTodayOrLater(appointments, true), true)[0] || {};
  const formatDate = date => moment(date, RAILS_DATE).format(DISPLAY_DATE);
  const formatTime = time => moment(time, MOMENT_TIME).format('h:mm A');
  const didAnswer = customerAnswered === 'yes';
  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>{`${title} ${didAnswer ? 'Answered' : 'Voicemail'}`} Script</h4>
    </div>
    <Fragment>
      {didAnswer ? (<Fragment>
        <div className={S.scriptContainer}>
          <p className={S.scriptUserNote}>USER NOTE: Did the customer say the delivery went okay?</p>
          <br />
          <Button
            label="YES"
            flat inverse ripple
            disabled={deliveryOkay === 'yes'}
            className={S.standardButton}
            onClick={() => handleBasicQuestion('deliveryOkay', 'yes')}
          />
          <Button
            label="NO"
            flat inverse ripple
            disabled={deliveryOkay === 'no'}
            className={S.standardButton}
            onClick={() => handleBasicQuestion('deliveryOkay', 'no')}
          />
        </div>
        {deliveryOkay && <ContainerDiv>
          <DropdownDiv condition={deliveryOkay}>
            <div className={S.scriptContainer}>
              {deliveryOkay === 'yes' ? (<Fragment>
                <p>
                  That{'\''}s great. We look forward to your installation scheduled for <span className={S.scriptText}>{formatDate(appt.start_date)}</span>,
                  with an arrival window of <span className={S.scriptText}>{formatTime(appt.arrival_start_time)} - {formatTime(appt.arrival_end_time)}</span>.
                  Do you have any questions or concerns about your upcoming installation that I can answer for you at this time?
                </p>
                <br />
                <p className={S.scriptUserNote}>USER NOTE: Please allow time for the customer to respond and address any questions/concerns.</p>
                <br />
                <p>Alright, we look forward to helping you complete your project.</p>
                <br />
                <p>Have a great day!</p>
              </Fragment>) : (<Fragment>
                <p className={S.scriptUserNote}>
                  USER NOTE: Address the customer{'\''}s concern. If the delivery was not completed, reschedule the customer.
                  If items are missing, reassure the customer that you will work with the store to receive the missing items and follow up with an update.
                </p>
              </Fragment>)}
            </div>
          </DropdownDiv>
        </ContainerDiv>}
      </Fragment>) : (<div className={S.scriptContainer}>
        <p>If your delivery did not go as expected or you have questions about your upcoming installation, please contact us at 866-774-4411.</p>
        <br />
        <p>Thank you and have a great day!</p>
      </div>)
    }
    </Fragment>
  </Card>);
};

FollowUpDeliveryCallScript.propTypes = {
  title: PropTypes.string,
  phase: PropTypes.object,
  customerAnswered: PropTypes.string,
  deliveryOkay: PropTypes.string,
  handleBasicQuestion: PropTypes.func,
};

export default FollowUpDeliveryCallScript;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/followUpDeliveryCallScript.jsx